<template>
  <v-app id="inspire">
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-list dense>

        <v-list-item link to="/home">
          <v-list-item-action>
            <v-icon>mdi-home</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Home</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/user" v-if="$auth.check('ROLE_ADMIN')">
          <v-list-item-action>
            <v-icon>mdi-account-group</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>Usuários</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/olt">
          <v-list-item-action>
            <v-icon>mdi-server-outline</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>OLT</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item link to="/ont">
          <v-list-item-action>
            <v-icon>mdi-router-network</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>ONT</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>

    <v-app-bar app clipped-left dark v-if="$auth.check()">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>Parks NMS</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-chip class="ma-2" color="default"><v-avatar left color="secondary"><v-icon>mdi-account</v-icon></v-avatar>{{ $auth.user().username }}</v-chip>
      <v-btn icon large @click="logout()">
        <v-icon>mdi-exit-run</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <v-container fluid>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer app>
      <span>&copy; 2026</span>
    </v-footer>
  </v-app>
</template>

<script>
import router from "./router/index.js";
export default {
  data: () => ({
    drawer: false
  }),
  created: function() {
    var me = this;
    this.$auth
      .remember()
      .then(function() {
        me.drawer = true;
      })
      .catch(function() {
        me.logout();
      });
  },
  methods: {
    logout: function() {
      this.$auth.logout();
      this.drawer = false;
      router.push("/login");
    }
  }
};
</script>

<style>
h1 {
  font-weight: 300;
}
table th {
  background-color: #f0f0f0;
}
</style>
